import { render } from "./insideLocation.vue?vue&type=template&id=0bddba9a"
import script from "./insideLocation.vue?vue&type=script&lang=js"
export * from "./insideLocation.vue?vue&type=script&lang=js"

import "./insideLocation.vue?vue&type=style&index=0&id=0bddba9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__